var activeLine = [];
$(document).ready(function(){
    $('#dataTableBuilder').on('draw.dt', addActiveLine);
    
    $(document).on("change",".input-quantity", updateLine);
    $('#select-all-group').on('click', selectAllGroup);

    $('.btn-delete-ligne').on("click", deleteLine);

    $('#submit-articles').on('submit', function(e) {
        activeLine.forEach(e => {
            $(this).append(`<input type="hidden" name='${e.name}' value='${e.qty}' /> `);
        });
        activeLine = [];
        return true;
    });

    $('.commandes-quantity').on("input", updateTotalPrice);

    $('.cancelModal').on('show.bs.modal', () => { 
            $("textarea[name='cancel_comment']").trigger('focus');
    });
});

function deleteLine(e){
    e.preventDefault();

    // Get the button
    currentBtn = $(this);
    id = currentBtn.data('id');

    if(id != undefined){
        $.ajax({
            url: route('commandes.deleteligne'),
            type: 'GET',
            data: {
                id:id,
            },
            success: function(){
                // Récupération du compteur et cast
                compteur = $('#count-articles').text();
                compteur = Number(compteur);

                // Suppression si il y a bien un article
                if (compteur > 0) {
                    compteur = compteur-1;
                }
                // Changement du texte
                $('#count-articles').text(compteur);

                // Suppression de la ligne donné
                currentBtn.parent().parent().parent().remove();
                updateTotalPrice();
            },
            error: function (e){
                console.log(e.status + ' : ' + e.responseText);
            }
        });
    }
    else{
        // Récupération du compteur et cast
        compteur = $('#count-articles').text();
        compteur = Number(compteur);

        // Suppression si il y a bien un article
        if (compteur > 0) {
            compteur = compteur-1;
        }
        // Changement du texte
        $('#count-articles').text(compteur);

        // Suppression de la ligne donné
        currentBtn.parent().parent().parent().remove();

        updateTotalPrice();
    }
}

function updateLine(e){
    // Put active or remove it if quantity is above 1    
    if($(this).val() > 0)
        $(this).closest('tr').addClass('active');
    else
        $(this).closest('tr').removeClass('active')
    toggleActiveLine($(this));
}

function addActiveLine() {
    $('.input-quantity').each(function(e) {
        if ($(this).val() > 0) 
        {
            toggleActiveLine($(this));
            $(this).closest('tr').addClass('active');
        }
        else
        {
           let index = activeLine.findIndex(e => e.name == $(this).attr('name'))
           if (index > -1)
           {
                $(this).val(activeLine[index].qty);
                $(this).closest('tr').addClass('active');
           }
        }
    });
}

function selectAllGroup(e) {
    let checkboxes = document.getElementsByClassName('grouped-checkbox');
    if (e.target.innerHTML == 'Tout séléctionner')
    {
        checkboxes.forEach(function(checkbox) {
            checkbox.checked = true;
        });
        e.target.innerHTML = 'Retirer les séléctions';
    }
    else
    {
        checkboxes.forEach(function(checkbox) {
            checkbox.checked = false;
        });
        e.target.innerHTML = 'Tout séléctionner';
    }
}

function toggleActiveLine(elem) {
    let index = activeLine.findIndex(e => e.name == elem.attr('name'));
    if (index > -1 && elem.val() > 0)
        activeLine[index].qty = elem.val();
    else if (index > -1 && elem.val() == 0)
        activeLine.splice(index, 1);
    else if (index == -1 && elem.val() > 0)
        activeLine.push({
            'name' : elem.attr('name'),
            'qty' : elem.val()
        });
}

function updateTotalPrice() {
    // Get total price element
    let total = $('.js-total-price');

    // Set the table to index to
    let table = $('.table-liste-commandes');

    // Boucle sur toutes les lignes
    let quantities = table.find('.commandes-quantity');
    let prices = table.find('.price-article');
    let partial_total = 0;

    // Boucle de calcul
    for (let index = 0; index < quantities.length; index++) {
        partial_total += quantities[index].value * prices[index].innerText;
    }

    // Set the text
    total.text(financial(partial_total));
}

function financial(x) {
    return Number.parseFloat(x).toFixed(5);
}
